export default [
    // packages ordered by priority
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFTTNL",
    "PFPTT",
    "PFPTTF",
    "PFPTTNL",
    "PFTTUK",
    "PFPTTUK",
    "PFTTF",
    "PFP",
    "PF",
    "HS",
];
